import { useEffect, useState } from "react"
import Tabs from "Components/molecule/tabs"
import { GrossMarginKpis } from "models/financial-kpi"
import KpiCard from "./kpi-card"
import KpiTable from "./kpi-table"

interface GrossMarginSectionProps {
    data: GrossMarginKpis | null
    isLoading: boolean
}

// Gross Margin: one tab per division (department rows expand to their regions), then the company total.
const GrossMarginSection = ({ data, isLoading }: GrossMarginSectionProps) => {
    const headers = (data?.tabs ?? []).map(t => t.label)
    const [activeTab, setActiveTab] = useState<string>("")

    useEffect(() => {
        if (headers.length && !headers.includes(activeTab)) setActiveTab(headers[0])
    }, [data])

    return (
        <KpiCard title="Gross Margin" subtitle="Target from Department KPIs · actuals from the Gross Margin Report" isLoading={isLoading || !data}>
            {data && <>
                <Tabs
                    headers={headers}
                    tabs={Object.fromEntries(data.tabs.map(t => [t.label, <KpiTable key={t.key} rows={t.rows} />]))}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                />
                <div className="mt-2">
                    <KpiTable rows={[data.total]} />
                </div>
            </>}
        </KpiCard>
    )
}

export default GrossMarginSection
